<template>
  <div class="TkBreadcrumbs">
    <section id="breadcrumbs">
      <ol
        itemscope=""
        itemtype="http://schema.org/BreadcrumbList"
        class="TkBreadcrumbs_list"
      >
        <li
          v-for="(item, index) in items"
          :key="index"
          class="TkBreadcrumbs_item"
          itemprop="itemListElement"
          itemscope=""
          itemtype="http://schema.org/ListItem"
        >
          <template v-if="item.url">
            <tk-link
              :href="item.url"
              itemprop="item"
              class="TkBreadcrumbs_itemLink"
            >
              <span itemprop="name">{{item.name}}</span>
            </tk-link>
          </template>
          <template v-else>
            <span itemprop="name">{{item.name}}</span>
          </template>
          <span
            v-if="index < items.length - 1"
            class="pan-arrow"
          >
            &gt;
          </span>
          <meta
            itemprop="position"
            :content="index + 1"
          >
        </li>
      </ol>
    </section>
  </div>
</template>

<script>
import TkLink from '../TkLink/TkLink'

export default {
  name: 'TkBreadcrumbs',
  components: {
    TkLink,
  },
  props: {
    items: {
      type: Array,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.TkBreadcrumbs {
  padding-bottom: 10px;
  box-sizing: border-box;
  width: 100%;
  overflow: auto;
}
.TkBreadcrumbs_list {
  margin: 0 auto;
}
.TkBreadcrumbs_item {
  display: inline;
  font-size: 11px;
}
.TkBreadcrumbs_itemLink {
    color: #333;
    text-decoration: none;
}
</style>
